import * as types from '../../../constants/actionTypes';

export const PAGE_SIZE = 25;
export const ORDER = 'COMPANY_NAME_DESC';

export function fetchAllCompanies({ limit, offset, order }) {
    const params = {
        limit: limit || PAGE_SIZE,
        offset: offset || 0,
        order: order || ORDER,
    };
    return {
        types: [
            types.FETCH_COMPANIES,
            types.FETCH_COMPANIES_SUCCESS,
            types.FETCH_COMPANIES_FAIL,
        ],
        promise: (client) =>
            client.get('/api/profiles', {
                params,
            }),
    };
}

export function searchByName({ name }) {
    return {
        types: [
            types.FETCH_COMPANIES,
            types.FETCH_COMPANIES_SUCCESS,
            types.FETCH_COMPANIES_FAIL,
        ],
        promise: (client) =>
            client.get('/api/profiles/by-name', { params: { name } }),
    };
}
